// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hq-0";